<template>
    <v-app-bar>

        <!-- Logo -->
        <div>
            <img src="@assets/images/header/logo-nlb-buy&go.png" alt="NLB Buy&Go logo" class="logo">
        </div>

        <div class="d-flex ga-4 align-center">
            <div class="section-heading mt-0 mb-0 mr-4 d-md-block d-none">
                {{ pageTitle }}
            </div>

            <!-- Share btn -->
            <!-- <v-btn class="btn btn--primary-outline btn--round" @click="shareContent">
                <img src="@assets/images/header/icon-share.svg" alt="Share">
            </v-btn> -->

            <!-- Close btn -->
            <v-btn
                v-if="!router.currentRoute.value.fullPath.includes('/end-success') && !router.currentRoute.value.fullPath.includes('/end-fail')"
                class="btn btn--primary-outline btn--round" @click="appStore.CancelProcedure()">
                <img src="@assets/images/header/icon-close.svg" alt="Close">
            </v-btn>

        </div>

    </v-app-bar>
</template>

<script setup lang="ts">
    import { useAppStore } from "@/app/store/app/app-store";
    import router from "@/app/router";

    const props = defineProps<{
        pageTitle: string;
    }>();

    const appStore = useAppStore();

    const shareContent = async () => {
        if (navigator.share) {
            try {
                await navigator.share({
                    // title: '',
                    text: 'Deli povezavo',
                    url: window.location.href
                });
            } catch (error) {
                console.error('Napaka pri deljenju:', error);
            }
        } else {
            console.log('Deljenje ni podprto na tem napravi ali brskalniku.');
        }
    };
</script>